code

<template>
    <!--        <img alt="Vue logo" src="./assets/logo.png">-->
    <!--        <HelloWorld msg="Welcome to Your Vue.js App Abdullah"/>-->
    <div class="container">
        <div class="row fh-row justify-content-center">
            <div class="col-md-6 align-self-center">
                <mdb-card class="z-depth-1">
                  <mdb-card-header color="white">
                    <div class="container-fluid">
                      <div class="row">
                        <div :class="$store.state.reseller_logo? 'col-6': 'col-3'" class="col-md-4 align-self-center text-left">
                          <img v-if="$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                        </div>
                        <div :class="$store.state.reseller_logo? 'col-2': 'col-6'" class="col-md-4">
                          <img v-if="!$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                        </div>
                        <div :class="$store.state.reseller_logo? 'col-4': 'col-3'" class="col-md-4 col-4 align-self-center text-right">
                          <img v-if="$store.state.reseller_logo" :src="$store.state.reseller_logo" alt="Card image cap" class="img-fluid img-banner"/>
                        </div>
                      </div>
                    </div>
                  </mdb-card-header>
                    <mdb-card-body class="text-center">
                        <!--                            <mdb-card-image src="./assets/logo.png" alt="" class="img-fluid"></mdb-card-image>-->
                        <div class="container-fluid">
                            <div class="row hh-row">
                                <div class="col-12 align-self-center">
                                    <h4>Proceed to Agent Verification</h4>
                                    <img src="@/assets/face_verification.png" alt class="img-fluid"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <p class>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="container-fluid">
                            <div class="row justify-content-center">
                                <div class="col-md-4">
                                    <mdb-btn block color="primary" class size="md"
                                             @click="$router.push('/verify-agent')">Next
                                    </mdb-btn>
                                </div>
                            </div>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "About",
        components: {
            // HelloWorld,
        }
    };
</script>
<style lang="scss">
    @import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");

    $image-path: "~@/../mdb/mdbvue/img";
</style>
